<template>
    <div class="cart-box">
        <!-- Новий дизайн: заголовок панелі «Кошик» з кількістю й «Очистити»; на комп'ютері липкий угорі панелі -->
        <div v-if="$v2" class="bp-cart-head">
            <h2 class="bp-cart-head__title"><inline-svg class="bp-cart-head__ic" src="/img/icons/shopping-cart.svg" width="20" height="20" fill="currentColor" aria-hidden="true"></inline-svg>Кошик</h2>
            <span v-if="products.length && !finished" class="bp-cart-head__count"><b>{{ cartCount.n }}</b> {{ cartCount.word }}</span>
            <template v-if="products.length && !finished && !payOnline">
                <span v-if="confirmClear" class="bp-cart-head__ask" role="group" aria-label="Очистити кошик">
                    Очистити все?
                    <button type="button" class="bp-cart-head__clear bp-cart-head__yes" @click="clearCart">Так</button>
                    <button type="button" class="bp-cart-head__clear" @click="cancelClear">Ні</button>
                </span>
                <button v-else type="button" class="bp-cart-head__clear bp-cart-head__clear--ic" @click="askClear"><span class="bp-cart-head__trash" v-html="icons.trash"></span>Очистити</button>
            </template>
        </div>
        <div v-if="products.length && !finished && !payOnline" class="cart-box-full">
            <div style="margin-bottom: 25px" class="bp-cart-list">
                <div v-for="(product, index) in products" :key="index" class="cart-product-box" :class="{ 'bp-cart-last': $v2 && index == products.length - 1 }">
                    <div class="cart-product-box__body">
                        <!-- Новий дизайн: сіра іконка смітника без плашки, ціль натиску 40 px -->
                        <button v-if="$v2 && product.freeBeverage != 1" type="button" class="bp-cart-remove" aria-label="Видалити з кошика" title="Видалити"
                                @click="removeProduct(product)" v-html="icons.trash"></button>
                        <div v-else-if="!$v2" style="
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
" @click="removeProduct(product)">
                            <inline-svg src="/img/icons/close-box.svg" width="25" height="25" :fill="$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                        </div>

                        <div style="margin-right: 14px;">
                            <img :src="product.thumbnail" style="width: 125px;border-radius: 8px;" :class="{ 'bp-cart-img': $v2, 'bp-cart-img--pizza': $v2 && product.category_id == 1 }">
                        </div>

                        <div style="width: 100%;">
                            <div class="cart-product-box__title">
                                <template v-if="$v2">{{ cartTitle(product) }}</template>
                                <template v-else>{{ product.title }} ({{ product.size }})</template>
                            </div>
                            <!-- Новий дизайн: склад у кошику не показуємо — рядок компактний -->
                            <div v-if="!$v2" class="cart-product-box__description">
                                <span v-if="(product.size == '30 см' && product.weight_30 > 0) || (product.size == '50 см' && product.weight_50 > 0)" class="product-box-description__weight">{{
                                        product.size == '30 см' ? product.weight_30 : product.weight_50
                                }} г – </span>
                                {{ product.description }}
                            </div>
                            <div style="text-align: left;font-size: 0.8rem;color: #aaa;margin-top: 4px"
                                 v-if="product.additionaIngredients.length">
                                <span v-if="$v2" class="bp-add-ic" v-html="icons.cheese"></span><b>Додатки: </b> <span v-for="(ingredient, index) in product.additionaIngredients"
                                                       :key="ingredient.index">{{ ingredient.title }}<span
                                v-if="index < product.additionaIngredients.length - 1">, </span> </span>
                            </div>
                        </div>
                    </div>

                    <!-- Новий дизайн: ліворуч сума рядка (CSS order), праворуч лічильник; «ціна × к-сть» — лише коли кількість > 1 -->
                    <div class="bp-cart-row" style="margin-top: 30px;text-align: left;display: flex;justify-content: space-between;align-items: center;width: 100%">
                        <div v-if="!$v2" style="font-weight: 700">
                            {{ product.price }} грн
                        </div>

                        <!-- Новий дизайн: подарунковий напій — завжди 1, без лічильника -->
                        <div class="quantity-box" v-if="!($v2 && product.freeBeverage == 1)">
                            <div class="quanity-button quanity-button--minus" @click="changeQuanity('minus', product, index)"
                                 :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Менше' : null"
                                 @keydown.enter.space.prevent="changeQuanity('minus', product, index)">
                                <span v-if="$v2" class="bp-qty-ic" v-html="icons.minus"></span>
                                <template v-else>-</template>
                            </div>
                            <div class="quanity-input">{{ product.quanity }}</div>
                            <div class="quanity-button quanity-button--plus" @click="changeQuanity('plus', product, index)"
                                 :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-label="$v2 ? 'Більше' : null"
                                 @keydown.enter.space.prevent="changeQuanity('plus', product, index)">
                                <span v-if="$v2" class="bp-qty-ic" v-html="icons.plus"></span>
                                <template v-else>+</template>
                            </div>
                        </div>

                        <div v-if="$v2" class="bp-line-sum">
                            <div v-if="product.freeBeverage == 1" class="bp-line-sum__total">0 грн <s class="bp-line-sum__old">{{ getProductPrice(product) }} грн</s></div>
                            <div v-else class="bp-line-sum__total">{{ getProductPrice(product) }} грн</div>
                            <div v-if="product.quanity > 1" class="bp-line-sum__unit">{{ product.price }} грн × {{ product.quanity }}</div>
                        </div>
                    </div>

                    <div v-if="!$v2" style="margin: 8px 0 0 auto; font-weight: 700">
                        Сума: <span style="color: #AB2321;">{{ getProductPrice(product) }} грн</span>
                    </div>
                </div>
                <!-- Новий дизайн: усі акції одним стилем — картка з міткою «Акція» (bp-promo-card / bp-promo-badge) -->
                <div class="cart-free-beverage-box" :class="{ 'bp-promo-card': $v2 }" v-if="secondPizzaOfDiscount">
                    <!-- Новий дизайн: іконка в колі, заголовок і пояснення; напої — кола з фото, вибраний з червоною обвідкою й галочкою -->
                    <template v-if="$v2">
                        <div class="bp-promo-head">
                            <span class="bp-promo-ic" v-html="icons.gift"></span>
                            <div>
                                <div class="bp-promo-title">Напій у подарунок</div>
                                <div class="bp-promo-text">За {{ pizzaCount }} піци — оберіть один, він безкоштовний</div>
                            </div>
                        </div>
                        <div class="bp-gift-list" role="radiogroup" aria-label="Напій у подарунок">
                            <button type="button" v-for="(freeBeverage, index) in freeBeverages" :key="freeBeverage.id" class="bp-gift" role="radio"
                                    :aria-checked="freeBeverage.id == getSelectedFreeBeverageId() ? 'true' : 'false'" @click="changeFreeBeverage(index)">
                                <span class="bp-gift__ph"><img :src="freeBeverage.thumbnail" alt=""></span>
                                <span class="bp-gift__t">{{ giftName(freeBeverage.title) }}</span>
                            </button>
                        </div>
                    </template>
                    <div v-else style="color: rgba(255, 206, 0, 0.68)">При замовленні 2 або 3 піц напій на вибір – безкоштовно!</div>
                    <div class="free-beverage__list" v-if="!$v2">
                        <div v-for="(freeBeverage, index) in freeBeverages" :key="freeBeverage.id"
                             :class="(freeBeverage.id == getSelectedFreeBeverageId() ? 'selected-free-beverage': '') + ' free-beverage__item'"
                             style="padding: 2px;opacity: 0.4;font-size: 0.9rem;" @click="changeFreeBeverage(index)">
                            <img :src="freeBeverage.thumbnail" style="width: 80px;border-radius: 8px">
                            <div style="margin-top: 7px;text-align: center">
                                {{ freeBeverage.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Новий дизайн: при одній піці — підказка, що друга дасть напій у подарунок (шкала «1 з 2») -->
                <div v-if="$v2 && pizzaCount == 1" class="bp-promo-card bp-promo-card--hint" role="note">
                    <div class="bp-promo-head">
                        <span class="bp-promo-ic" v-html="icons.gift"></span>
                        <div>
                            <div class="bp-promo-title">Ще одна піца — і напій у подарунок</div>
                            <div class="bp-promo-text">За 2 або 3 піци — 1 л напою на вибір безкоштовно</div>
                        </div>
                    </div>
                    <div class="bp-steps">
                        <i class="on"></i><i></i>
                        <span>1 з 2</span>
                        <router-link :to="'/' + $route.params.locationCity">Обрати піцу</router-link>
                    </div>
                </div>

                <!-- Новий дизайн: підказка про 4-ту піцу — над підсумками, зі шкалою «3 з 4» -->
                <div v-if="$v2 && showThreePizzaDiscount" class="bp-promo-card bp-promo-card--hint" role="note">
                    <div class="bp-promo-head">
                        <span class="bp-promo-ic" v-html="icons.pizzaSlice"></span>
                        <div>
                            <div class="bp-promo-title">Ще одна піца — і найдешевша за пів ціни</div>
                            <div class="bp-promo-text">Знижка 50 % на кожну 4-ту піцу в замовленні</div>
                        </div>
                    </div>
                    <div class="bp-steps">
                        <i class="on"></i><i class="on"></i><i class="on"></i><i></i>
                        <span>3 з 4</span>
                        <router-link :to="'/' + $route.params.locationCity">Обрати піцу</router-link>
                    </div>
                </div>

                <!-- Новий дизайн: з 4 піц — акція вже діє: картка з тлом і сумою знижки, щоб було видно, як і подарунок -->
                <div v-if="$v2 && fourPizzaDiscount > 0" class="bp-promo-card bp-promo-card--won" role="note">
                    <div class="bp-promo-head">
                        <span class="bp-promo-ic" v-html="icons.pizzaSlice"></span>
                        <div>
                            <div class="bp-promo-title">{{ pizzaCount >= 8 ? 'Кожна 4-та піца за пів ціни' : '4-та піца за пів ціни' }}</div>
                            <div class="bp-promo-amount">−{{ fourPizzaDiscount }} грн</div>
                        </div>
                    </div>
                </div>

                <!-- Новий дизайн: з 2 піц — гра «Хто платить?» для компанії -->
                <div v-if="$v2 && features.whoPays && pizzaCount >= 2" class="bp-promo-card bp-promo-card--hint bp-wp-cartcard" role="note">
                    <div class="bp-promo-head">
                        <span class="bp-promo-ic" v-html="icons.dice"></span>
                        <div>
                            <div class="bp-promo-title">Хто платить?</div>
                            <div class="bp-promo-text">Замовляєте компанією — вирішіть грою: перчик, рулетка, кубики</div>
                        </div>
                    </div>
                    <router-link class="bp-wp-cartcard__go" :to="{ name: 'who-pays', params: $route.params }">Грати</router-link>
                </div>

                <!-- Новий дизайн: контурна іконка перед кожним підписом (src/v2icons.js) -->
                <div class="cart-total-amounts">
                    <div class="cart-total-amounts__title"><span v-if="$v2" class="bp-ticon" v-html="icons.receipt"></span>Сума:</div>
                    <div class="cart-total-amounts__value">{{ getTotalPrice() }} грн</div>
                </div>
                <div class="cart-total-amounts" :class="{ 'bp-disc-row': $v2 }" v-if="!$v2 || getTotalDiscount() > 0">
                    <div class="cart-total-amounts__title"><span v-if="$v2" class="bp-ticon" v-html="icons.percent"></span>Знижка:</div>
                    <div class="cart-total-amounts__value">{{ $v2 ? '−' : '' }}{{ getTotalDiscount() }} грн</div>
                </div>
                <!-- Новий дизайн: за що знижка — дрібно під нею, замість окремих рядків «Акція» і «Самовиніс»
                     (акції не діють разом: самовиніс — 1 піца, напій — 2–3, 4-та піца — від 4) -->
                <!-- Підпис, за що знижка: дублює картку акції вище, бо підсумки читають окремо, а картка буває далеко вгорі -->
                <div v-if="$v2 && getTotalDiscount() > 0" class="bp-disc-sub">{{ [secondPizzaOfDiscount ? 'напій у подарунок' : '', fourPizzaDiscount ? '4-та піца за пів ціни' : '', takeAwayDiscount ? 'самовиніс −7 %' : ''].filter(Boolean).join(' · ') }}</div>
                <div class="cart-total-amounts" v-if="type == 'delivery'">
                    <div class="cart-total-amounts__title"><span v-if="$v2" class="bp-ticon" v-html="icons.car"></span>Доставка:</div>
                    <div class="cart-total-amounts__value" v-if="$v2 && getDeliveryPrice() == '???'"><span class="bp-muted-val">після адреси</span></div>
                    <div class="cart-total-amounts__value" v-else>{{ getDeliveryPrice() }} грн</div>
                </div>
                <div class="cart-total-amounts" :class="{ 'bp-total-final': $v2 }">
                    <div class="cart-total-amounts__title"><span v-if="$v2" class="bp-ticon" v-html="icons.wallet"></span>До сплати:</div>
                    <div class="cart-total-amounts__value">{{ getTotalPrice() - getTotalDiscount() + (getDeliveryPrice() == '???' ? 0 : getDeliveryPrice()) }} грн</div>
                </div>
                <div class="cart-total-amounts" v-if="!$v2 && takeAwayDiscount">
                    <div class="cart-total-amounts__title"><span v-if="$v2" class="bp-ticon" v-html="icons.percent"></span>Самовиніс (-7%):</div>
                    <div class="cart-total-amounts__value">{{ Math.round(takeAwayDiscount) }} грн</div>
                </div>
                <div class="cart-total-amounts" :class="{ 'bp-promo': $v2 }" v-if="!$v2 && fourPizzaDiscount">
                    <div class="cart-total-amounts__title" :style="$v2 ? null : 'color: rgba(255, 206, 0, 0.68)'"><span v-if="$v2" class="bp-promo-badge bp-promo-badge--sm"><span class="bp-promo-badge__ic" v-html="icons.gift"></span>Акція</span>На кожну 4-ту піцу – знижка 50%:</div>
                    <div class="cart-total-amounts__value">{{ $v2 ? '−' : '' }}{{ Math.round(fourPizzaDiscount) }} грн</div>
                </div>
            </div>

            <!-- <div style="text-align: left;padding-bottom: 14px;" v-if="secondPizzaOfDiscount">
                Друга піца (-35%): -{{ Math.round(secondPizzaOfDiscount, 2)}} грн
            </div> -->

            <div v-if="!$v2 && showThreePizzaDiscount"
                style="text-align: left;padding-bottom: 14px;background-color: rgba(255, 206, 0, 0.68);padding: 14px;font-size: 0.9rem;">
                Якщо Ви замовляєте 3 піци – 4-та (найдешевша у чеку) –лише за 50% вартості. Оберіть, будь ласка, 4-ту піцу, щоб отримати знижку!
            </div>

            <!-- Новий дизайн: перемикач доступний і з клавіатури (Tab, Enter / пробіл) -->
            <div class="cart-order-type-box" :role="$v2 ? 'group' : null" :aria-label="$v2 ? 'Спосіб отримання' : null">
                <div @click="changeOrderType('delivery')" :class="type == 'delivery' ? 'order-type-text-selected' : 'order-type-text'"
                     :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-pressed="$v2 ? String(type == 'delivery') : null"
                     @keydown.enter.space.prevent="changeOrderType('delivery')">
                    <span v-if="$v2" class="bp-otype-ic" v-html="icons.car"></span>
                    Доставка
                </div>

                <div @click="changeOrderType('take-away')" :class="type == 'take-away' ? 'order-type-text-selected' : 'order-type-text'"
                     :tabindex="$v2 ? 0 : null" :role="$v2 ? 'button' : null" :aria-pressed="$v2 ? String(type == 'take-away') : null"
                     @keydown.enter.space.prevent="changeOrderType('take-away')">
                    <span v-if="$v2" class="bp-otype-ic" v-html="icons.store"></span>
                    Самовиніс
                </div>
            </div>

            <div v-if="!$v2 && errors.length" style="margin-top: 25px; margin-bottom: 14px; text-align: left; color: #fb3431; font-weight: bold;">
                <div v-for="error in errors" :key="error">
                    {{ error }}
                </div>
            </div>

            <div class="cart-form" style="text-align: left;margin-top: 25px;">
                <!-- Новий дизайн: контурна іконка зліва в кожному полі (bp-fwrap / bp-fico, v2.css) -->
                <div class="bp-fwrap bp-fwrap--name">
                    <span v-if="$v2" class="bp-fico" v-html="icons.user"></span>
                    <input type="text" :class="fieldClass(!userInfo.name)" v-model="userInfo.name" placeholder="Ім'я">
                </div>
                <!-- Новий дизайн: незмінний префікс «+38» і маска «096 292 87 84»; у userInfo.phone, як і раніше, лише 10 цифр (0962928784) -->
                <div class="bp-fwrap bp-fwrap--tel" style="margin-top: 14px;">
                    <span v-if="$v2" class="bp-fico" v-html="icons.phone"></span>
                    <span v-if="$v2" class="bp-fprefix" :class="{ 'bp-fprefix--filled': phoneDisplay }" ref="telPrefix" aria-hidden="true">+38</span>
                    <input v-if="$v2" type="tel" inputmode="tel" autocomplete="tel-national" :class="fieldClass(!isValidPhone, 'phone')" :style="telPad ? { paddingLeft: telPad } : null"
                           :value="phoneDisplay" @input="onPhoneInput" placeholder="050 111 22 33" aria-label="Номер телефону (+38)">
                    <input v-else type="text" :class="fieldClass(!isValidPhone, 'phone')" v-model="userInfo.phone" @keyup="validatePhoneField" placeholder="Номер телефону">
                    <div class="bp-err" v-if="fieldErrors.phone">{{ fieldErrors.phone }}</div>
                </div>

                <div v-if="type == 'take-away' && takeawayLocations.length > 0">
                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;">
                            Оберіть точку для самовиносу:
                        </div>
                        <!-- Новий дизайн: власний список (components/BpSelect.vue), та сама модель -->
                        <BpSelect v-if="$v2" v-model="userInfo.location_id" :options="locationOptions" placeholder="Точка для самовиносу" :icon="icons.store"
                                  :invalid="!!fieldErrors.location_id"/>
                        <select v-else :class="fieldClass(!userInfo.location_id, 'location_id')" v-model="userInfo.location_id" required>
                            <option value="" disabled selected>Точка для самовиносу</option>
                            <option :value="location.id" v-for="location in takeawayLocations" :key="location.id">{{ location.address }}</option>
                        </select>
                        <div class="bp-err" v-if="fieldErrors.location_id">{{ fieldErrors.location_id }}</div>
                    </div>

                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;" :class="{ 'bp-flabel': $v2 }">Час самовиносу:</div>
                        <div v-if="$v2" class="bp-size bp-day" role="group" aria-label="День самовиносу">
                            <button type="button" v-for="day in deliveryDays" :key="day.key" :aria-pressed="deliveryDay == day.key ? 'true' : 'false'" @click="setDeliveryDay(day.key)">{{ day.label }}</button>
                        </div>
                        <BpSelect v-if="$v2" v-model="userInfo.delivery_at" :options="timeOptions" aria-label="Час самовиносу" :icon="icons.clock"/>
                        <select v-else class="form-control" id="exampleFormControlSelect2" v-model="userInfo.delivery_at">
                            <option v-for="time in this.deliveryWorkTimes" :value="time.value">
                                {{ time.start }} {{ time.end ? '- ' + time.end  : ''}}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="type == 'delivery'">
                    <div style="margin-top: 14px">
                        <!-- Новий дизайн: список із пошуком; вибір іде в ту саму модель і selectCity, що й у select -->
                        <BpSelect v-if="$v2" v-model="userInfo.city" :options="cityOptions" placeholder="Населений пункт" searchable search-placeholder="Почніть вводити назву" :icon="icons.pin"
                                  :invalid="!!fieldErrors.city" @change="selectCity({ target: { value: $event } })"/>
                        <select v-else :class="fieldClass(!userInfo.city, 'city')" id="exampleFormControlSelect1" v-model="userInfo.city"
                                v-on:change="selectCity" required>
                            <option value="" disabled selected>Населений пункт</option>
                            <option :value="city.name" v-for="city in cities" :key="city.id">{{ city.name }}</option>
                        </select>
                        <div class="bp-err" v-if="fieldErrors.city">{{ fieldErrors.city }}</div>
                    </div>

                    <div class="bp-fwrap" style="margin-top: 14px;position: relative;" v-if="userInfo.city">
                        <span v-if="$v2" class="bp-fico" v-html="icons.signpost"></span>
                        <input type="text" :class="fieldClass(!userInfo.street, 'street')" v-model="userInfo.street" v-on:keyup="findStreet" placeholder="Вулиця">
                        <div class="street-suggestions-section" v-if="streetSuggestions.length">
                            <div>
                                <div v-for="street in streetSuggestions" :key="street.id"
                                     style="padding: 7px;padding-left: 14px;font-weight: bold;cursor:pointer;"
                                     @click="selectStreetPrice(street)">
                                    {{ street.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bp-err" v-if="userInfo.city && fieldErrors.street">{{ fieldErrors.street }}</div>
                    <div v-if="selectedCity && (!selectedCity.is_validate_streets || selectedStreet)">
                        <div style="margin-top: 7px;font-size: 0.9rem;background-color: #AB2321;color: #fff;text-align: center;padding: 7px;" v-if="showMinPriceAlert()">
                            На жаль, мінімальна сума замовлення за Вашою адресою: <b>{{ minPrice }}</b> грн
                        </div>
                        <!-- Новий дизайн: вартість доставки — тихий рядок без заливки; скільки лишилось до безкоштовної — смужка (умови ті самі) -->
                        <div class="bp-dnote" v-if="$v2 && (getTotalPrice() - getTotalDiscount()) < getFreeDeliveryPrice()" role="status">
                            <div class="bp-dnote__row"><span class="bp-dnote__ic" v-html="icons.car"></span><span>Вартість доставки <b>{{ getDeliveryPrice() == '???' ? 0 : getDeliveryPrice() }} грн</b></span></div>
                            <div class="bp-dnote__more">Ще <b>{{ getFreeDeliveryPrice() - (getTotalPrice() - getTotalDiscount()) }} грн</b> до безкоштовної доставки</div>
                            <div class="bp-dnote__bar" aria-hidden="true"><span :style="{ width: Math.min(100, Math.round((getTotalPrice() - getTotalDiscount()) / getFreeDeliveryPrice() * 100)) + '%' }"></span></div>
                        </div>
                        <div class="bp-dnote" v-else-if="$v2 && !showMinPriceAlert() && (getTotalPrice() - getTotalDiscount()) > getFreeDeliveryPrice()" role="status">
                            <div class="bp-dnote__row bp-dnote__row--ok"><span class="bp-dnote__ic bp-dnote__ic--ok" v-html="icons.check"></span><span>Доставка безкоштовна</span></div>
                        </div>
                        <div style="margin-top: 7px;font-size: 0.9rem;background-color: #FFB343; color: #fff;text-align: center;padding: 7px;" v-if="!$v2 && (getTotalPrice() - getTotalDiscount()) < getFreeDeliveryPrice()">
                            Вартість доставки <b>{{ getDeliveryPrice() == '???' ? 0 : getDeliveryPrice() }}</b> грн. Безкоштовна доставка від <b>{{ getFreeDeliveryPrice() }}</b> грн
                        </div>
                        <div style="margin-top: 7px;font-size: 0.9rem;background-color: #00BB77; color: #fff;text-align: center;padding: 7px;" v-if="!$v2 && !showMinPriceAlert() && (getTotalPrice() - getTotalDiscount()) > getFreeDeliveryPrice()">
                            Доставка безкоштовна!
                        </div>
                    </div>
                    <div style="margin-top: 7px;font-size: 0.9rem;background-color: #AB2321;color: #fff;text-align: center;padding: 7px;" v-if="!checkStreetAvailability()">
                        На жаль, Ваша адреса поза межами зони доставки
                    </div>
                    <div style="margin-top: 14px;display: flex;justify-content: space-between">
                        <div class="bp-fwrap" style="width: 48%">
                            <span v-if="$v2" class="bp-fico" v-html="icons.home"></span>
                            <input type="text" :class="fieldClass(!userInfo.house)" v-model="userInfo.house" placeholder="Будинок">
                        </div>
                        <div class="bp-fwrap" style="width: 48%">
                            <span v-if="$v2" class="bp-fico" v-html="icons.door"></span>
                            <input type="text" class="form-control" v-model="userInfo.apartment" placeholder="Квартира">
                        </div>
                    </div>

                    <div style="margin-top: 14px">
                        <div style="margin-bottom: 4px;" :class="{ 'bp-flabel': $v2 }">Час доставки:</div>
                        <div v-if="$v2" class="bp-size bp-day" role="group" aria-label="День доставки">
                            <button type="button" v-for="day in deliveryDays" :key="day.key" :aria-pressed="deliveryDay == day.key ? 'true' : 'false'" @click="setDeliveryDay(day.key)">{{ day.label }}</button>
                        </div>
                        <BpSelect v-if="$v2" v-model="userInfo.delivery_at" :options="timeOptions" aria-label="Час доставки" :icon="icons.clock"/>
                        <select v-else class="form-control" id="exampleFormControlSelect2" v-model="userInfo.delivery_at">
                            <option v-for="time in this.deliveryWorkTimes" :value="time.value">
                                {{ time.start }} {{ time.end ? '- ' + time.end  : ''}}
                            </option>
                        </select>
                    </div>
                </div>

                <div style="margin-top: 14px">
                    <BpSelect v-if="$v2" v-model="userInfo.payment_type" :options="paymentOptions" placeholder="Оплата" :icon="paymentIcon"
                              :invalid="!!fieldErrors.payment_type"/>
                    <select v-else :class="fieldClass(!userInfo.payment_type, 'payment_type')" id="payment_type" v-model="userInfo.payment_type">
                        <option value="" disabled selected>Оплата</option>
                        <option value="Готівка">Готівка</option>
                        <option value="Картка">Картка</option>
                        <option value="Оплата карткою online" style="font-weight: bold;">Оплата карткою online
                        </option>
                    </select>
                    <div class="bp-err" v-if="fieldErrors.payment_type">{{ fieldErrors.payment_type }}</div>
                </div>

                <div class="bp-fwrap bp-fwrap--area" style="margin-top: 14px">
                    <span v-if="$v2" class="bp-fico" v-html="icons.chat"></span>
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                              v-model="userInfo.comment" placeholder="Побажання">></textarea>
                </div>

                <div style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center; width: 100%">
                        <label class="form-check-label" style="font-size: 1.1rem"><span v-if="$v2" class="bp-fico-inline" v-html="icons.phoneOff"></span>Не телефонувати</label>
                    <!-- v-model без двокрапки: `:v-model` — це звичайний атрибут, а не директива,
                         і з квітня 2024 перемикач клацав, не записуючи нічого в call_back.
                         Бек із call_back = true дописує «Не перетелефоновувати» в коментар -->
                    <toggle-button :color="{checked: '#AB2321', unchecked: '#787880', disabled: '#CCCCCC'}" switch-color="white" :width=51 :height=31 v-model="userInfo.call_back" />
                </div>

                <div v-if="$v2 && otherErrors.length" class="bp-form-errors" role="alert">
                    <div v-for="error in otherErrors" :key="error">{{ error }}</div>
                </div>

                <p v-if="closedNote" class="bp-closed-note" role="status">{{ closedNote }}</p>

                <div style="margin-top: 14px">
                    <!-- Новий дизайн: поки замовлення надсилається — спінер і «Обробка замовлення…» (кнопка тієї ж висоти й ширини) -->
                    <button class="order-button" :class="{ 'is-loading': $v2 && ordered }" :aria-busy="$v2 && ordered ? 'true' : null"
                            @click="order()" :disabled="ordered || !!closedNote">
                        <template v-if="$v2 && ordered"><span class="bp-spinner" aria-hidden="true"></span><span>Обробка замовлення…</span></template>
                        <template v-else-if="$v2"><span class="bp-btn-ic" v-html="icons.checkCircle"></span><span>Замовити</span></template>
                        <template v-else>Замовити</template>
                    </button>
                </div>
                <br>
            </div>
        </div>

        <!-- Новий дизайн: порожній кошик — той самий значок візка, що в заголовку «Кошик» і на кнопках «В кошик» -->
        <div class="center-cart-section bp-cart-empty" v-if="$v2 && !products.length && !finished">
            <span class="bp-cart-empty__icon"><inline-svg src="/img/icons/shopping-cart.svg" width="56" height="56" fill="currentColor" aria-hidden="true"></inline-svg></span>
            <div class="bp-cart-empty__title">Ваш кошик порожній</div>
            <div class="bp-cart-empty__note">Додайте щось смачне з меню</div>
        </div>
        <div class="center-cart-section" v-if="!$v2 && !products.length && !finished">
            <div style="margin-bottom: 25px">
                <inline-svg src="/img/icons/shopping-cart.svg" width="70" height="70"
                            :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                <br>
                Ваш кошик порожній
            </div>
        </div>

        <div class="center-cart-section" v-if="payOnline && !finished">
            <div id="liqpay_checkout"></div>
        </div>

        <div class="center-cart-section" v-if="finished && !$v2">
            {{ orderText }}
        </div>

        <!-- Новий дизайн: замовлення прийняте — номер, сума, куди й коли, що буде далі. Лишається, доки клієнт
             не повернеться до меню чи не покладе нову страву (старий показував рядок тексту на 2 с) -->
        <div class="bp-done" v-if="finished && $v2" role="status">
            <span class="bp-done__icon" v-html="icons.check"></span>
            <div class="bp-done__title">Дякуємо за замовлення!</div>
            <div class="bp-done__num" v-if="lastOrder && lastOrder.id">Замовлення № {{ lastOrder.id }}</div>
            <dl class="bp-done__facts" v-if="lastOrder">
                <div><dt>До сплати</dt><dd>{{ lastOrder.total }} грн</dd></div>
                <div v-if="lastOrder.place"><dt>{{ lastOrder.type == 'delivery' ? 'Доставка' : 'Самовиніс' }}</dt><dd>{{ lastOrder.place }}</dd></div>
                <div><dt>Час</dt><dd>{{ lastOrder.time }}</dd></div>
            </dl>
            <p class="bp-done__note" v-if="lastOrder">{{ doneNote }}</p>
            <a v-if="lastOrder && lastOrder.payOnline && lastOrder.id" class="order-button bp-done__pay"
               :href="'https://api.pizza.black/payment/liqpay/' + encodeURIComponent(lastOrder.id)" target="_blank" rel="noopener">Оплатити онлайн</a>
            <button type="button" class="bp-done__back" @click="closeDone()">Повернутися до меню</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import InlineSvg from 'vue-inline-svg';
import {ToggleButton} from 'vue-js-toggle-button'
import BpSelect from '@/components/BpSelect.vue'
import { ICONS } from '@/v2icons'
import { V2_FEATURES } from '@/v2features'
import { isOpenNow, hhmm, OPEN_FROM, tomorrowSlots } from '@/workHours'

// Повідомлення checkForm, які новий дизайн показує під самим полем (fieldErrors)
const FIELD_ERRORS = [
    'Вкажіть валідний номер телефону',
    'Оберіть населений пункт',
    'Оберіть коректну вулицю зі списку',
    'Оберіть тип оплати',
    'Оберіть точку для самовиносу',
];

export default {
    name: 'Cart',
    components: {
        VueSimpleSuggest,
        InlineSvg,
        ToggleButton,
        BpSelect
    },
    data() {
        return {
            icons: ICONS,
            features: V2_FEATURES,
            deliveryWorkTimes: [],
            deliveryDay: 'today', // новий дизайн: «Сьогодні | Завтра» над часом доставки й самовиносу
            tomorrowTimes: [],
            isValidPhone: false,

            userInfo: {
                'name': '',
                'phone': '',
                'location_id': null,
                'city': '',
                'city_id': 0,
                'street': '',
                'street_id': 0,
                'house': '',
                'apartment': '',
                'payment_type': '',
                'comment': '',
                'call_back': false,
                'delivery_price': 0,
                'free_delivery_price': 0,
                'delivery_at': null
            },
            type: 'delivery',
            errors: [],
            // Була невдала спроба замовити — лише після неї новий дизайн підсвічує поля
            tried: false,
            products: [],
            pizzas: [],
            beverages: [],
            ordered: false,
            finished: false,
            payOnline: false,

            takeAwayDiscount: 0,
            showSecondPizzaOf: false,
            secondPizzaOfDiscount: 0,
            fourPizzaDiscount: 0,
            // Подарунки приходять лише з /api/free-beverages. Раніше тут стояв
            // вписаний руками список (Coca-Cola id 43 за 35 грн…), і кошик клав
            // його в замовлення, поки справжній список ще вантажився.
            freeBeverages: [],
            freeBeverageIndex: 0,
            pizzaCount: 0,
            showThreePizzaDiscount: false,
            confirmClear: false, // новий дизайн: «Очистити все? Так / Ні» у заголовку кошика
            confirmClearTimer: null,
            telPad: null, // новий дизайн: відступ цифр після «+38» — за справжньою шириною префікса в тому шрифті, що завантажився
            streets: '',
            streetSuggestions: [],
            selectedStreet: '',
            minPrice: 0,
            takeawayLocations: [],
            cities: [],
            selectedCity: '',
            orderText: 'Дякуємо за замовлення! Очікуйте дзвінка!',
            lastOrder: null // новий дизайн: що показати після замовлення (orderSummary)
        }
    },

    computed: {
        // Новий дизайн: що буде далі — оплата, нічне замовлення, дзвінок чи «Не телефонувати»
        doneNote() {
            const order = this.lastOrder;
            if (!order) return '';
            if (order.payOnline) return 'Сторінка оплати відкрилась у новій вкладці. Не бачите її — натисніть «Оплатити онлайн».';
            if (!order.open) {
                return order.noCall
                    ? 'Зараз ми зачинені — почнемо готувати після ' + hhmm(OPEN_FROM) + '.'
                    : 'Зараз ми зачинені — зателефонуємо після ' + hhmm(OPEN_FROM) + ', щоб підтвердити замовлення.';
            }
            return order.noCall ? 'Дзвонити не будемо, як ви просили.' : 'Оператор зателефонує, щоб підтвердити замовлення.';
        },
        // Пункти списків нового дизайну (BpSelect) — ті самі значення, що в <option> старого
        cityOptions() {
            return this.cities.map(city => ({ value: city.name, label: city.name }));
        },
        locationOptions() {
            return this.takeawayLocations.map(location => ({ value: location.id, label: location.address }));
        },
        // Новий дизайн: «Сьогодні» — слоти з бекенду (з «Якнайшвидше»), «Завтра» — ті самі години на завтра (src/workHours.js)
        timeOptions() {
            const times = this.deliveryDay == 'tomorrow' ? this.tomorrowTimes : this.deliveryWorkTimes;
            return times.map(time => ({ value: time.value, label: time.start + (time.end ? ' - ' + time.end : '') }));
        },
        deliveryDays() {
            return [{ key: 'today', label: 'Сьогодні' }, { key: 'tomorrow', label: 'Завтра' }];
        },
        paymentOptions() {
            return ['Готівка', 'Картка', 'Оплата карткою online'].map(value => ({ value, label: value, icon: this.paymentIcons[value] }));
        },
        paymentIcons() {
            return { 'Готівка': ICONS.cash, 'Картка': ICONS.card, 'Оплата карткою online': ICONS.smartphone };
        },
        // Іконка в полі «Оплата» — за вибраним пунктом; до вибору — картка
        paymentIcon() {
            return this.paymentIcons[this.userInfo.payment_type] || ICONS.card;
        },
        // Номер у полі групами 3-3-2-2: «096 292 87 84»
        phoneDisplay() {
            const d = String(this.userInfo.phone || '').replace(/\D/g, '');
            return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean).join(' ');
        },

        // Новий дизайн: що саме не дає оформити, під кожним полем. Умови — ті самі, що в checkForm
        fieldErrors() {
            if (!this.$v2 || !this.tried) return {};
            const errors = {};
            if (!this.userInfo.phone || !this.isValidPhone) {
                errors.phone = 'Вкажіть номер телефону повністю — 10 цифр';
            }
            if (this.type == 'delivery') {
                if (!this.selectedCity) {
                    errors.city = 'Оберіть населений пункт';
                } else if (this.selectedCity.is_validate_streets && (!this.selectedStreet || !this.selectedStreet.name)) {
                    errors.street = 'Оберіть вулицю зі списку підказок';
                }
            }
            if (this.type == 'take-away' && !this.userInfo.location_id && this.takeawayLocations.length > 0) {
                errors.location_id = 'Оберіть точку для самовиносу';
            }
            if (!this.userInfo.payment_type) {
                errors.payment_type = 'Оберіть спосіб оплати';
            }
            return errors;
        },

        // Решта помилок (поза зоною доставки, мінімальна сума, відповідь сервера) — над кнопкою.
        // Помилки полів checkForm тут не повторюємо: вони вже видні під полями
        otherErrors() {
            return this.errors.filter(error => !FIELD_ERRORS.includes(error));
        },

        // Чому зараз не можна замовити (лише новий дизайн): закрито все або лише доставку
        closedNote() {
            if (!this.$v2) return '';
            const closed = this.$store.state.closed;
            if (closed.all) return 'Зараз ми не приймаємо замовлення. Кошик збережеться — замовте, коли відкриємося.';
            if (closed.delivery && this.type == 'delivery') return 'Доставка зараз не працює — оберіть «Самовиніс».';
            return '';
        },

        // «1 товар», «2 товари», «5 товарів» — за сумою кількостей у рядках кошика, без подарункового напою
        cartCount() {
            const n = this.products.reduce((sum, p) => sum + (p.freeBeverage == 1 ? 0 : (Number(p.quanity) || 1)), 0);
            const m10 = n % 10, m100 = n % 100;
            const word = m10 == 1 && m100 != 11 ? 'товар' : (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? 'товари' : 'товарів');
            return { n, word };
        },
    },

    watch: {
        products: function (newProducts, oldProducts) {
            this.checkDiscount();
        },

        // Новий дизайн: поклали нову страву, поки видно подяку, — повертаємо кошик
        'products.length': function (count, before) {
            if (this.$v2 && this.finished && count > before) {
                this.finished = false;
                this.lastOrder = null;
            }
        },

        // Доставка не працює — одразу пропонуємо самовиніс
        '$store.state.closed.delivery': function (off) {
            if (this.$v2 && off && this.type == 'delivery') this.changeOrderType('take-away');
        },
    },

    methods: {
        // Старий вигляд: поле червоне чи зелене від самого початку.
        // Новий: спокійне, червоне лише після невдалої спроби і лише те, що справді заважає (ім'я й будинок сайт не вимагає)
        fieldClass(bad, field) {
            if (!this.$v2) {
                return (bad ? 'is-invalid' : 'is-valid') + ' form-control';
            }
            return 'form-control' + (field && this.fieldErrors[field] ? ' is-invalid' : '');
        },

        // Новий дизайн: маска телефону. Беремо лише цифри; «+380…» / «380…» (вставка, автозаповнення) → «0…»;
        // не більше 10 цифр. У модель іде те саме, що й раніше вводили руками: 10 цифр без пробілів
        onPhoneInput(e) {
            const el = e.target, prev = String(this.userInfo.phone || '');
            let caret = el.value.slice(0, el.selectionStart).replace(/\D/g, '').length;
            let d = el.value.replace(/\D/g, '');
            if (d.length > 10 && d.indexOf('38') === 0) { d = d.slice(2); caret = Math.max(0, caret - 2); }
            // Стерли пробіл — стираємо цифру поруч, інакше маска поверне пробіл і курсор застрягне
            if (d === prev && e.inputType === 'deleteContentBackward' && caret > 0) { d = d.slice(0, caret - 1) + d.slice(caret); caret--; }
            else if (d === prev && e.inputType === 'deleteContentForward') { d = d.slice(0, caret) + d.slice(caret + 1); }
            d = d.slice(0, 10);
            caret = Math.min(caret, d.length);
            this.userInfo.phone = d;
            this.validatePhoneField();
            const shown = this.phoneDisplay;
            el.value = shown;
            let pos = 0;
            for (let seen = 0; pos < shown.length && seen < caret; pos++) if (/\d/.test(shown[pos])) seen++;
            if (document.activeElement === el) el.setSelectionRange(pos, pos);
        },

        fitTelPrefix() {
            const pr = this.$refs.telPrefix;
            if (!pr) return;
            const pad = (pr.offsetLeft + pr.getBoundingClientRect().width + 4.5).toFixed(2) + 'px';
            if (pad !== this.telPad) this.telPad = pad;
        },

        validatePhoneField(event) {
            const validationRegex = /^\d{10}$/;
            if (this.userInfo.phone.match(validationRegex)) {
                this.isValidPhone = true;
            } else {
                this.isValidPhone = false;
            }
        },

        removeProduct(product) {
            this.$store.commit('removeFromCart', product);
            this.products = this.$store.state.cart;
        },

        // Новий дизайн: «Очистити» в заголовку кошика. Перший клік питає «Очистити все? Так / Ні» на тому ж місці
        // (без window.confirm — у вбудованих переглядачах він мовчки повертає false); за 4 с без дії питання зникає.
        // «Так» — та сама мутація emptyCart, що й після замовлення
        askClear() {
            this.confirmClear = true;
            clearTimeout(this.confirmClearTimer);
            this.confirmClearTimer = setTimeout(this.cancelClear, 4000);
        },
        cancelClear() {
            clearTimeout(this.confirmClearTimer);
            this.confirmClear = false;
        },
        clearCart() {
            this.cancelClear();
            this.$store.commit('emptyCart');
            this.products = this.$store.state.cart;
        },

        // Новий дизайн: знімок замовлення для подяки — до очищення кошика. Сума — та сама, що в рядку «До сплати»
        orderSummary(data) {
            const tomorrow = this.deliveryDay == 'tomorrow';
            const time = (tomorrow ? this.tomorrowTimes : this.deliveryWorkTimes).find(item => item.value && item.value == this.userInfo.delivery_at);
            const point = this.takeawayLocations.find(location => location.id == this.userInfo.location_id);
            const delivery = this.getDeliveryPrice();
            const address = [this.userInfo.city, this.userInfo.street, this.userInfo.house].filter(Boolean).join(', ')
                + (this.userInfo.apartment ? ', кв.' + String.fromCharCode(160) + this.userInfo.apartment : ''); // «кв. 22» не розриваємо
            return {
                id: data && data.id,
                total: this.getTotalPrice() - this.getTotalDiscount() + (delivery == '???' ? 0 : delivery),
                type: this.type,
                // Адреса точки в базі — «🍕 вул. Липинського, 7;⌚️11:00-22:00»: лише адреса, без значків і годин
                place: this.type == 'delivery' ? address : (point ? point.address.split(';')[0].replace(/^[^\p{L}\d]+/u, '').trim() : ''),
                time: time ? (tomorrow ? 'Завтра, ' : '') + time.start + (time.end ? ' – ' + time.end : '') : 'Якнайшвидше',
                noCall: !!this.userInfo.call_back,
                payOnline: this.userInfo.payment_type == 'Оплата карткою online',
                open: isOpenNow(this.$store.state.closed),
            };
        },

        // «Завтра» — перший слот (12:00), «Сьогодні» — «Якнайшвидше»
        setDeliveryDay(day) {
            if (day == 'tomorrow') this.tomorrowTimes = tomorrowSlots();
            this.deliveryDay = day;
            this.userInfo.delivery_at = day == 'tomorrow' && this.tomorrowTimes.length ? this.tomorrowTimes[0].value : null;
        },

        closeDone() {
            this.finished = false;
            this.lastOrder = null;
            if (this.$route.name == 'cart') {
                this.$router.push({ name: 'pizza', params: { locationCity: this.$route.params.locationCity } });
            }
        },

        getProductPrice(product) {
            return product.price * product.quanity;
            return product.discountPrice ? product.discountPrice * product.quanity : product.price * product.quanity;
        },

        changeQuanity(way, product) {
            if (way == 'minus') {
                if (product.quanity == 1) {
                    return;
                }
                product.quanity--;
            }

            if (way == 'plus') {
                product.quanity++;
            }
            this.checkDiscount();

            this.$forceUpdate();
        },


        checkStreetAvailability() {
            if (this.selectedStreet && !this.selectedStreet.is_available) {
                return false;
            }

            return true;
        },

        checkForm() {
            this.errors = [];
            if (!this.userInfo.phone || !this.isValidPhone) {
                this.errors.push('Вкажіть валідний номер телефону');
                return false;
            }

            if (this.type == 'delivery') {
                if (!this.selectedCity) {
                    this.errors.push('Оберіть населений пункт');
                    return false;
                }

                if (this.selectedCity.is_validate_streets && (!this.selectedStreet || !this.selectedStreet.name)) {
                    this.errors.push('Оберіть коректну вулицю зі списку');
                    return false;
                }

                if (this.selectedCity.is_validate_streets) {
                    let streets = this.streets.find(street => street.name == this.userInfo.street)
                    if (streets.length == 0) {
                        this.errors.push('Оберіть коректну вулицю зі списку');
                        return false;
                    }
                }

                if (this.selectedStreet && !this.selectedStreet.is_available) {
                    this.errors.push(`На жаль, Ваша адреса поза межами зони доставки`);
                    return false;
                }

                if (this.showMinPriceAlert()) {
                    this.errors.push(`На жаль, мінімальна сума замовлення за Вашою адресою: ${this.minPrice} гривень`);
                    return false;
                }

                if (!this.userInfo.payment_type) {
                    this.errors.push('Оберіть тип оплати');
                    return false;
                }
            }

            if (this.type == 'take-away') {
                // Раніше спосіб оплати був обов'язковий лише для доставки, і самовинос
                // ішов на бекенд із порожнім значенням — чек друкувався без способу оплати.
                if (!this.userInfo.payment_type) {
                    this.errors.push('Оберіть тип оплати');
                    return false;
                }

                if (!this.userInfo.location_id && this.takeawayLocations.length > 0) {
                    this.errors.push('Оберіть точку для самовиносу');
                    return false;
                }
            }
            // if(!this.userInfo.name) {
            //     this.errors.push('Вкажіть ім\'я');
            //     return false;
            // }
            return true;
        },

        findStreet(event) {
            const selectedCity = this.selectedCity;
            this.streetSuggestions = this.streets.filter(function filterByID(street) {
                if (street.city_id == selectedCity.id && street.name.toUpperCase().includes(event.target.value.toUpperCase())) {
                    return true;
                }
                return false;
            });
            this.selectedStreet = null;
        },

        selectStreetPrice(street) {
            this.userInfo.street = street.name;
            this.userInfo.street_id = street.id;
            this.selectedStreet = street;

            this.minPrice = this.selectedStreet.min_price;
            this.streetSuggestions = [];
        },

        selectCity(event) {
            let city = this.cities.find(city => city.name == event.target.value);
            this.selectedCity = city;
            this.minPrice = this.selectedCity.min_price;

            this.userInfo.city_id = this.selectedCity.id;
            this.userInfo.street = '';
            this.selectedStreet = '';
        },

        showMinPriceAlert() {
            return (this.minPrice > (this.getTotalPrice() - this.getTotalDiscount()));
        },

        order() {
            this.ordered = true;
            this.$set(this.userInfo, 'type', this.type);
            if (this.checkForm() == false) {
                this.ordered = false;
                if (this.$v2) {
                    this.tried = true;
                    // До першого поля з помилкою чи повідомлення над кнопкою, а не на верх сторінки
                    this.$nextTick(() => {
                        const target = this.$el.querySelector('.cart-form .is-invalid, .bp-form-errors');
                        if (target) target.scrollIntoView({block: 'center', behavior: 'smooth'});
                    });
                } else {
                    window.scrollTo(0, 0);
                }
                return;
            }

            if(this.type != 'take-away') {
                this.$set(this.userInfo, 'location_id', null);
            }

            this.$set(this.userInfo, 'discount', this.getTotalDiscount());

            let url = `${Vue.prototype.SERVER_URL}/api`;

            if(localStorage.getItem('locationCityId')) {
                url += '/' + localStorage.getItem('locationCityId');
            }

            this.userInfo.delivery_price = (this.getDeliveryPrice() == '???' ? 0 : this.getDeliveryPrice());

            url += '/order';
            // let url = localStorage.getItem('locationCityId')
            axios.post(url, {
                order: this.userInfo,
                products: this.products
            }).then(response => {
                this.ordered = false;
                if (this.$v2) this.lastOrder = this.orderSummary(response.data);
                gtag('event', 'conversion', {
                    'send_to': 'AW-700415606/945qCJq978UBEPb8_c0C',
                    'transaction_id': response.data.id,
                    'value': response.data.total_price,
                    'currency': 'UAH'
                });

                dataLayer.push({
                    'event': 'conversion'
                });

                if (this.userInfo.payment_type == 'Оплата карткою online') {
                    window.open(`https://api.pizza.black/payment/liqpay/${response.data.id}`, '_blank');
                    this.payOnline = false;
                    this.finished = true;

                    // this.payOnline = true;
                    // this.finished = false;
                    //
                    // LiqPayCheckout.init({
                    //     data: response.data.liqpay_data,
                    //     signature: response.data.liqpay_signature,
                    //     embedTo: "#liqpay_checkout",
                    //     language: "uk",
                    //     mode: "embed" // embed || popup
                    // }).on("liqpay.callback", (data) => {
                    //     if (data.status == "success") {
                    //         this.payOnline = false;
                    //         this.finished = true;
                    //         this.$store.commit('emptyCart');
                    //         this.products = this.$store.state.cart;
                    //         setTimeout(() => {
                    //             let liqpayElement = document.getElementById('liqpay_checkout');
                    //             liqpayElement.innerHTML = "";
                    //             this.ordered = false;
                    //             this.finished = false;
                    //         }, 2000);
                    //     }
                    //
                    // }).on("liqpay.ready", function (data) {
                    //     // ready
                    // }).on("liqpay.close", function (data) {
                    //     // close
                    // });

                    // window.LiqPayCheckoutCallback = function() {

                    // };
                    // window.LiqPayCheckoutCallback();
                } else {
                    // this.orderText = response.data.text;
                    this.finished = true;
                    this.$store.commit('emptyCart');
                    this.products = this.$store.state.cart;
                    // Новий дизайн тримає подяку, доки клієнт сам не повернеться до меню (closeDone)
                    if (!this.$v2) {
                        setTimeout(() => {
                            this.ordered = false;
                            this.finished = false;
                        }, 2000);
                    }
                }
            }).catch(e => {
                if (!this.$v2) {
                    this.errors.push(e.response.data.status);
                    return;
                }
                // Новий дизайн: після відмови кнопка знову активна, інакше «Замовити» лишалась вимкненою до перезавантаження
                this.ordered = false;
                const message = (e.response && e.response.data && e.response.data.status) ||
                    'Не вдалося надіслати замовлення. Спробуйте ще раз або зателефонуйте нам.';
                if (!this.errors.includes(message)) this.errors.push(message);
            });
        },

        // Сума свого списку: на сторінці кошика Cart змонтований двічі, і після видалення списки розходяться.
        // Панель кошика на телефоні рахує store окремо (getters.cartTotal)
        getTotalPrice() {
            let totalPrice = 0;
            this.products.forEach(e => {
                totalPrice += e.price * e.quanity;
            });
            return totalPrice;
        },

        changeOrderType(type) {
            this.type = type;
            this.checkDiscount();
        },

        checkDiscount() {
            let numberOfPizzas = 0;
            this.showSecondPizzaOf = false;
            this.showThreePizzaDiscount = false;

            this.takeAwayDiscount = 0;
            this.secondPizzaOfDiscount = 0;
            this.fourPizzaDiscount = 0;

            for (let i = 0; i < this.products.length; i++) {
                if (this.products[i].category_id == 1) {
                    this.$set(this.products[0], 'discountPrice', 0);
                    numberOfPizzas += this.products[i].quanity;
                }
            }

            // Акція: напій у подарунок за 2 або 3 піци (з 03.11 і за 3); з 4 піц — 50 % на кожну 4-ту
            this.pizzaCount = numberOfPizzas;
            const freeBeverageDeal = numberOfPizzas == 2 || numberOfPizzas == 3;
            let hasFreeBeverageIndex = this.getSelectedFreeBeverageIndex();
            if (!freeBeverageDeal && hasFreeBeverageIndex != -1) {
                this.products.splice(hasFreeBeverageIndex, 1);
            }

            if (freeBeverageDeal) {
                this.takeAwayDiscount = 0;

                let hasFreeBeverage = this.getSelectedFreeBeverageIndex();
                // Поки список подарунків не завантажився (або він порожній),
                // нічого не кладемо: mounted() перерахує кошик, коли він прийде.
                if (hasFreeBeverage == -1 && this.freeBeverages[this.freeBeverageIndex]) {
                    this.products.push(this.freeBeverages[this.freeBeverageIndex]);
                    hasFreeBeverage = this.getSelectedFreeBeverageIndex();
                }

                // Знижка — ціна подарунка, що лежить у кошику, а не позиції зі
                // списку: інакше вони розходились (кола 35 грн, знижка 50).
                if (hasFreeBeverage > -1) {
                    this.secondPizzaOfDiscount = this.products[hasFreeBeverage].price;
                }

                this.showSecondPizzaOf = true;
            }

            if (numberOfPizzas == 3) {
                this.showThreePizzaDiscount = true;
            }

            if (numberOfPizzas >= 4) {
                this.fourPizzaDiscount = 0;
                let numberOfFreePizzas = Math.floor(numberOfPizzas / 4);
                while (numberOfFreePizzas > 0) {
                    for (let i = 0; i < this.products.length; i++) {
                        if (numberOfFreePizzas == 0) {
                            break;
                        }
                        if (this.products[i].category_id == 1) {
                            for (let j = 0; j < this.products[i].quanity; j++) {
                                if (numberOfFreePizzas == 0) {
                                    break;
                                }
                                this.fourPizzaDiscount += Math.round(this.products[i].priceWithoutAdditionals / 2);
                                numberOfFreePizzas--;
                            }
                        }
                    }
                }
            }

            if (this.type == 'take-away' && this.secondPizzaOfDiscount == 0 && this.fourPizzaDiscount == 0 && numberOfPizzas == 1) {
                this.getTakeAwayDiscount();
            }

            localStorage.setItem('cart', JSON.stringify(this.products));
        },

        getTakeAwayDiscount() {
            this.takeAwayDiscount = Math.round((this.getTotalPrice() - this.getTotalDiscount()) * 0.07);
        },

        getTotalDiscount() {
            return Math.round(this.takeAwayDiscount + this.secondPizzaOfDiscount + this.fourPizzaDiscount);
        },

        getDeliveryPrice() {
            if (this.type == 'take-away') {
                return 0;
            }

            if(!this.selectedCity) {
                return '???';
            }

            if(this.selectedCity.is_validate_streets && !this.selectedStreet) {
                return '???';
            }
            else if(this.selectedCity.is_validate_streets) {
                return this.getDeliveryPriceByCityOrStreet(this.selectedStreet);
            }

            return this.getDeliveryPriceByCityOrStreet(this.selectedCity);
        },

        getFreeDeliveryPrice() {
            if (this.type == 'take-away') {
                return 0;
            }

            if(!this.selectedCity) {
                return 0;
            }

            if(this.selectedCity.is_validate_streets && !this.selectedStreet) {
                return 0;
            }
            else if(this.selectedCity.is_validate_streets) {
                if((this.getTotalPrice() - this.getTotalDiscount()) < this.selectedStreet.min_price) {
                    return 0;
                }

                if((this.getTotalPrice() - this.getTotalDiscount()) < this.selectedStreet.free_delivery_price) {
                    return this.selectedStreet.free_delivery_price;
                }

                return 0;
            }

            if((this.getTotalPrice() - this.getTotalDiscount()) < this.selectedCity.min_price) {
                return 0;
            }

            if((this.getTotalPrice() - this.getTotalDiscount()) < this.selectedCity.free_delivery_price) {
                return this.selectedCity.free_delivery_price;
            }

            return 0;
        },

        getDeliveryPriceByCityOrStreet(cityOrStreet) {
            if((this.getTotalPrice() - this.getTotalDiscount()) < cityOrStreet.min_price) {
                return '???';
            }

            if((this.getTotalPrice() - this.getTotalDiscount()) < cityOrStreet.free_delivery_price) {
                // this.delivery_price = cityOrStreet.delivery_price;

                return cityOrStreet.delivery_price;
            }

            return 0;
        },

        // Новий дизайн: назва в кошику — піца з розміром, напій з об'єм «500 мл», снек без «(75 ml)»; подарунок без «у подарунок»
        cartTitle(product) {
            const title = product.freeBeverage == 1 ? this.giftName(product.title) : product.title;
            if (product.category_id == 1) return product.size ? title + ' (' + product.size + ')' : title;
            const ml = parseInt(product.volume || product.size);
            return product.is_beverage == 1 && ml > 0 ? title + ' (' + ml + ' мл)' : title;
        },

        // Новий дизайн: назва подарунка без «у подарунок» — про подарунок уже каже заголовок картки
        giftName(title) {
            return String(title).replace(/\s*у подарунок\s*/i, ' ').replace(/\s+/g, ' ').trim() || title;
        },

        getSelectedFreeBeverageIndex() {
            return this.products.findIndex(e => e.freeBeverage == 1);
        },

        getSelectedFreeBeverage() {
            return this.getSelectedFreeBeverageIndex() ? this.products[this.getSelectedFreeBeverageIndex()] : null;
        },

        getSelectedFreeBeverageId() {
            return this.getSelectedFreeBeverage() ? this.getSelectedFreeBeverage().id : null;
        },

        changeFreeBeverage(index) {
            this.freeBeverageIndex = index;
            let hasFreeBeverageIndex = this.getSelectedFreeBeverageIndex();
            if (hasFreeBeverageIndex != -1) {
                this.products.splice(hasFreeBeverageIndex, 1);
            }
            this.products.push(this.freeBeverages[this.freeBeverageIndex]);
            localStorage.setItem('cart', JSON.stringify(this.products));
        },

        getFreeBeverageID() {
            return this.products.find(e => e.freeBeverage == 1).id;
        },

        selectStreet(street) {
            this.userInfo.street = street.display;
        },

        getSuggestionList(street) {
            return fetch(`https://api.pizza.black/api/street/${street}`, {method: 'GET'})
                .then(response => response.json())
                .then(json => json.items); /*
                returns a promise with a list of star-wars characters
                */
        }
    },

    beforeDestroy() {
        clearTimeout(this.confirmClearTimer);
    },

    // Префікс «+38» стоїть поверх поля; цифри починаються за ним + 4,5 px — разом із бічними відступами гліфів це ≈ ширина пробілу.
    // Ширину міряємо, а не задаємо числом: без Inter (запасний шрифт) «+38» ширший і налазив на цифри
    updated() {
        this.fitTelPrefix();
    },

    mounted() {
        document.querySelector('body').style.overflow = '';
        if (this.$v2) {
            this.$nextTick(this.fitTelPrefix);
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitTelPrefix());
        }

        this.products = this.$store.state.cart;
        if (this.$v2 && this.$store.state.closed.delivery && this.type == 'delivery') this.changeOrderType('take-away');

        this.$store.dispatch('getFreeBeverages').then(beverages => {
            this.freeBeverages = beverages;
            if (!this.freeBeverages[this.freeBeverageIndex]) {
                this.freeBeverageIndex = 0;
            }

            // Подарунок, якого вже немає в списку (Coca-Cola 43 зі збереженого
            // кошика, вимкнений напій), прибираємо — checkDiscount покладе актуальний.
            let index = this.getSelectedFreeBeverageIndex();
            if (index != -1 && !this.freeBeverages.some(e => e.id == this.products[index].id)) {
                this.products.splice(index, 1);
            }

            this.checkDiscount();
        });

        this.$store.dispatch('getTakeawayLocations').then(takeawayLocations => {
            this.takeawayLocations = takeawayLocations;
        });

        this.$store.dispatch('getCities').then(cities => {
            this.cities = cities;
        });

        this.$store.dispatch('getStreets').then(streets => {
            this.streets = streets;
        });

        this.$store.dispatch('getDeliveryTimes').then(deliveryTimes => {
            this.deliveryWorkTimes = deliveryTimes;
        });
    }
}
</script>

<style>
/* Новий дизайн: чому «Замовити» зараз неактивна */
.bp-v2 .bp-closed-note { margin: 14px 0 0; padding: 12px 14px; border-radius: var(--bp-r-control); background: #f5f3ef; border-left: 3px solid #ab2321; color: #24242a; font-size: 15px; line-height: 20px; text-align: left; }
.bp-v2 .dark .bp-closed-note, .bp-v2 #app.dark .bp-closed-note { background: #2a2626; color: #f1efea; }
.order-button {
    background-color: #AB2321;
    border: unset;
    width: 100%;
    border-radius: 8px;
    padding-top: 14px;
    padding-bottom: 14px;
    color: #fff;
    font-weight: bold;
}

.order-button:disabled,
.order-button[disabled] {
    opacity: 0.1;
}

.center-cart-section {
    width: 100%;
    font-weight: bold;
    padding: 0;
}

.cart-quanity-box {
    height: 43px;
    width: 43px;
    border: 1px solid #eee;
    border-radius: 50%;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-type-text, .order-type-text-selected {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 50%;
    height: 40px;

    border-radius: 6px;

    color: white;
    font-weight: 700;
    text-align: center;

}
.order-type-text {
    cursor: pointer;
}

.order-type-text-selected {
    background: #AB2321;
}

.selected-free-beverage {
    opacity: 1 !important;
    font-weight: bold;
}

.cart-total-amounts {
    display: flex;
    justify-content: space-between;
    width: 100%;

    margin-bottom: 16px;
}

.cart-total-amounts__title {
    font-size: 1.1rem;
    font-weight: 700;
    color: black;
}

.dark {
    .cart-total-amounts__title {
        color: white;
    }
}

.cart-total-amounts__value {
    font-size: 1.1rem;
    font-weight: 700;
    color: #AB2321;
}

.autocomplete__icon {
    display: none;
}

.autocomplete__box {
    border: 0 !important;
    padding: 0 !important;
}

.autocomplete__results {
    left: 0;
}

.vue-simple-suggest.designed .input-wrapper input {
    border: 1px solid #ced4da;
    padding: .375rem .75rem;
}

.street-suggestions-section {
    position: absolute;
    width: 100%;
    background-color: rgb(255, 255, 255);
    top: calc(100% + 7px);
    border: 1px solid rgb(206, 212, 218);
    border-radius: 0.25rem;
    max-height: 340px;
    overflow-y: scroll;
    z-index: 999;
}

.street-suggestions-section::-webkit-scrollbar {
    width: 0.2em;
}

.street-suggestions-section::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.street-suggestions-section::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}

.cart-product-box {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgb(171, 35, 33);
    margin-bottom: 15px;
    padding-bottom: 20px;
    position: relative;
}

.cart-product-box__body {
    display: flex;
}

.cart-product-box__title {
    padding-right: 30px;
    text-align: left;
    font-weight: bold;
    font-size: 1.1rem;
    color: #AB2321;
}

.cart-product-box__description {
    text-align: left;
    font-size: 0.9rem;
    color: black;
}

.dark {
    .cart-product-box__description {
        color: white;
    }
}

.cart-free-beverage-box {
    margin-bottom: 14px;
    border: 1px solid rgb(238, 238, 238);
    border-radius: 8px;
    padding: 7px 4px;
}

.cart-order-type-box {
    display: flex;
    margin-top: 34px;
    border-radius: 6px;
    background: #BAAEAE;
}


.free-beverage__list {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    overflow-x: auto;
}
.free-beverage__list::-webkit-scrollbar {
    width: 2px;
}

.free-beverage__list::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
}

.free-beverage__list::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}


.free-beverage__list {
    scrollbar-width: auto;
    scrollbar-color: #39455c #17191e;
}

/* Chrome, Edge, and Safari */
.free-beverage__list::-webkit-scrollbar {
    width: 4px;
}

.free-beverage__list::-webkit-scrollbar-track {
    background: #17191e;
}

.free-beverage__list::-webkit-scrollbar-thumb {
    background-color: #39455c;
    border-radius: 10px;
    border: 1px solid #17191e;
}

.free-beverage__item {
    cursor: pointer;
}

</style>
